const getRouterBasename = () => {
  const ogTitleMeta = document.querySelector('meta[property="og:root_path"]');
  if (ogTitleMeta && typeof ogTitleMeta.getAttribute("content") === "string") {
    return ogTitleMeta.getAttribute("content")!;
  } else {
    return "";
  }
};

export default getRouterBasename;
